import apiClient from '../api/api'
import {
  PaginatedNotificationsResponse,
  UnreadCountResponse,
  MarkAsReadPayload,
  SendInvitationPayload,
  SendInvitationResponse,
} from '@/interfaces/notification'

export const notificationApi = {
  // Get paginated notifications
  getNotifications: async (
    page: number = 1,
    limit: number = 20
  ): Promise<PaginatedNotificationsResponse> => {
    const response = await apiClient.get<PaginatedNotificationsResponse>('/notifications', {
      params: { page, limit },
    })
    return response.data
  },

  // Get unread count
  getUnreadCount: async (): Promise<UnreadCountResponse> => {
    const response = await apiClient.get<UnreadCountResponse>('/notifications/unread-count')
    return response.data
  },

  // Mark specific notifications as read
  markAsRead: async (payload: MarkAsReadPayload): Promise<void> => {
    await apiClient.post('/notifications/mark-as-read', payload)
  },

  // Mark all notifications as read
  markAllAsRead: async (): Promise<void> => {
    await apiClient.post('/notifications/mark-all-as-read')
  },

  // Delete a notification
  deleteNotification: async (notificationId: string): Promise<void> => {
    await apiClient.delete(`/notifications/${notificationId}`)
  },

  // Send JD invitation
  sendInvitation: async (payload: SendInvitationPayload): Promise<SendInvitationResponse> => {
    const response = await apiClient.post<SendInvitationResponse>(
      '/notifications/send-invitation',
      payload
    )
    return response.data
  },
}
